import type { TaskListDensity } from '@/shared/store/preferences';

/**
 * How tall a Tasks page row is, per density (spec 114 US2).
 *
 * Fixed, and the one source: the virtualiser, the loading placeholders and the
 * row itself all read it, so they cannot drift apart (spec 110 FR-021).
 * Compact is one line; 40 px fits 1.6 times as many rows as 64.
 *
 * Its own module rather than beside `TaskRow`: a component module that also
 * exports a function cannot be fast-refreshed.
 */
export function taskRowHeight(density: TaskListDensity): number {
  return density === 'compact' ? 40 : 64;
}
